export { PLUGIN_KEY, PLUGIN_PRIORITY, DragToScroll } from "./dragToScroll.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/dragToScroll/index.mjs
// module id = 1346
// module chunks = 1